import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "page_base"
}
const _hoisted_2 = {
  id: "page_base_main",
  class: "page_base_main"
}
const _hoisted_3 = { class: "main_content" }

import HeaderNav from '@/components/organisms/HeaderNav'
import SideNav from '@/components/organisms/SideNav'
import FooterNav from '@/components/organisms/FooterNav'
import FeedbackDialog from '@/components/molecules/FeedbackDialog'
import { checkPlatform } from '@/js/utils/util'
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  __name: 'PageBase',
  setup(__props) {

const store = useStore()
const route = useRoute()

const initialized = ref<boolean>(false)

const isFeedbackDialog = computed<boolean>(() => checkPlatform() !== 'sm')

/**
 * 権限情報を取得
 */
const setUserInfo = async () => {
  await store.dispatch('auth/userInfo')

  // 権限情報を取得したら画面を表示させる
  initialized.value = true
}

/**
 * 端末認証keyを、URLパラメーターから削除
 */
const deleteURLAppKey = () => {
  const appKey = route.query.appKey

  if (appKey) {
    // urlのqueryパラメータを削除
    history.replaceState('', '', location.href.split('?')[0])
  }
}

// ログイン済みのユーザーかを判定
if (store.getters['auth/isLogin']) {
  deleteURLAppKey()
  setUserInfo()
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (initialized.value)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createVNode(_unref(SideNav), { id: "side-nav" }),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(HeaderNav), { id: "header-nav" }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_router_view)
          ]),
          _createVNode(_unref(FooterNav), { id: "footer" })
        ]),
        (_unref(isFeedbackDialog))
          ? (_openBlock(), _createBlock(_unref(FeedbackDialog), { key: 0 }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})